/**
 * 【【KYMW2100】VO
 *
 * @export SearchConditionOfOrderNumModel
 * @class SearchConditionOfOrderNumModel
 */
export class SearchConditionOfOrderNumModel {
  /** 受注コード */
  public OrderCode = String('');
  /** 媒体区分 */
  public MediumType = String('');
  /** 生協コード */
  public CoopCode = String('');
  /** Ｐコード */
  public PCode = String('');
  /** 注文コード(From) */
  public OrderNumFrom = String('');
  /** 注文コード(To) */
  public OrderNumTo = String('');
  /** ページ番号(From) */
  public PageNumFrom = String('');
  /** ページ番号(To) */
  public PageNumTo = String('');
  /** 使用注文コードFrom */
  public AvailableOrderNumFrom = String('');
  /** 使用注文コードTo */
  public AvailableOrderNumTo = String('');
  /** 未付番のみフラグ */
  public UnnumberedOnlyFlg = String('');
}
